import React from 'react';
import BaseSvgIcon, { SvgIconProps } from 'src/react_components/base-svg-icon';

// Equivalent of svg_icon defined in bendigo_helper
const SvgIcon = React.forwardRef<SVGSVGElement, SvgIconProps>((props, ref) => {
  const {
    icon, className, 'aria-label': ariaLabel, role, style, 'aria-hidden': ariaHidden, fill, stroke
  } = props;
  const classes = `icon ${className || ''}`;

  return (
    <BaseSvgIcon
      icon={icon}
      className={classes}
      style={style}
      aria-hidden={ariaHidden}
      aria-label={ariaLabel}
      role={role}
      ref={ref}
      fill={fill}
      stroke={stroke}
    />
  );
});

export default SvgIcon;
